module.exports = __webpack_public_path__ + "img/2021_10_dande_ninnaji_1011_fin_web.dc8e73d0.jpg";